import { BaseFetch } from "../main-model";
export default class AttachmentFileModel extends BaseFetch {
  getAttachmentFileById = (data) =>
    this.authFetch({
      url: "attachment-file/getAttachmentFileById",
      method: "POST",
      body: JSON.stringify(data),
    });
  getAttachmentFileByNoRef = (data) =>
    this.authFetch({
      url: "attachment-file/getAttachmentFileByNoRef",
      method: "POST",
      body: JSON.stringify(data),
    });
  updateAttachmentFileById = (data) =>
    this.authFetch({
      url: "attachment-file/updateAttachmentFileById",
      method: "POST",
      body: JSON.stringify(data),
    });
  updateMultiAttachmentFile = (data) =>
    this.authFetch({
      url: "attachment-file/updateMultiAttachmentFile",
      method: "POST",
      body: JSON.stringify(data),
    });

  insertAttachmentFile = (data) =>
    this.authFetch({
      url: "attachment-file/insertAttachmentFile",
      method: "POST",
      body: JSON.stringify(data),
    });
  deleteAttachmentFileById = (data) =>
    this.authFetch({
      url: "attachment-file/deleteAttachmentFileById",
      method: "POST",
      body: JSON.stringify(data),
    });
  insertUpload = (data) =>
    this.authUpload({
      url: "upload/insertUpload",
      method: "POST",
      body: data,
    });
  getUpload = (data) =>
    this.authParamsUpload({
      url: "upload/getUpload",
      method: "POST",
      body: JSON.stringify(data),
    });
  deleteUpload = (data) =>
    this.authDeleteUpload({
      url: "upload/deleteUpload",
      method: "POST",
      body: JSON.stringify(data),
    });
  getUploadImage = (data) =>
    this.authParamsUploadFileImageFetch({
      url: "upload/getUpload",
      method: "POST",
      body: data,
    });
}
